import { render, staticRenderFns } from "./stockholder.vue?vue&type=template&id=7711d8f6&scoped=true&"
import script from "./stockholder.vue?vue&type=script&lang=js&"
export * from "./stockholder.vue?vue&type=script&lang=js&"
import style0 from "./stockholder.vue?vue&type=style&index=0&id=7711d8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711d8f6",
  null
  
)

export default component.exports